export default __webpack_public_path__ + "af8ef7d190f1a06f489be7c661120919.svg";